import authSdk from '../sdk'

const datacentral = authSdk.createAxiosInstance({
    baseURL: import.meta.env.APP_API_URL,
})

export default datacentral
